import { useTranslation } from 'next-i18next';
import type { FC } from 'react';
import type { FormatJobType, JobCategory } from '@/api/cms/jobs/types';
import type { Banner, DefaultCmsDataResponse, Location } from '@/api/cms/types';
import Container from '@/components/layouts/Container';
import { recruitmentConfig } from '../recruitmentConfig';
import JobBanner from './JobBanner';
import NewJobPage from './NewJobPage';

type Props = {
  // Declare JobPage props
  jobCategories: DefaultCmsDataResponse<JobCategory>[];
  jobTypes: DefaultCmsDataResponse<FormatJobType>[];
  locations: DefaultCmsDataResponse<Location>[];
  homeBannerData?: DefaultCmsDataResponse<Banner>;
};

export const JobPage: FC<Props> = ({
  jobCategories,
  jobTypes,
  locations,
  homeBannerData,
}) => {
  const { t } = useTranslation(recruitmentConfig.i18nNamespaces);

  const bannerDesktop: string =
    homeBannerData?.attributes?.items
      ?.filter((item) => item.type === 'home' && item.desktop_image)
      .map((item) => ({
        url: item.desktop_image?.data?.attributes?.url,
      }))[0].url || '';

  return (
    <Container
      title={t('recruitment:recruitment.title')}
      image_url={bannerDesktop}
    >
      <main className="mt-header-mobile desktop:mt-header-desktop min-h-content flex w-full grow flex-col">
        <JobBanner />
        <NewJobPage
          jobCategories={jobCategories}
          jobTypes={jobTypes}
          locations={locations}
        />
      </main>
    </Container>
  );
};
